import _ from 'lodash';
import { connect } from 'react-redux';
import { addStation, updateStation, getStation } from '../modules/station';
import { showErrors } from '../modules/general';
import { bindActionCreators } from 'redux';

// XXX memoize

const mapStateToProps = (state, ownProps) => {
	const stationId = _.get(ownProps, ['match', 'params', 'stationId']);
	const station = (stationId) ? _.get(state.maps, ['station', stationId]) : undefined;
	return {
		station,
		userMap : state.maps.user,
	};
};

const mapDispatchToProps = dispatch => bindActionCreators({
	addStation, updateStation, getStation,
	showErrors,
}, dispatch);

export default connect(
	mapStateToProps,
	mapDispatchToProps
);
